class Product extends HTMLElement {
  constructor() {
    super();

    this.quantityInput = this.querySelector(".js-quantity-field");
    this.quantityUp = this.querySelector(".js-quantity-up");
    this.quantityDown = this.querySelector(".js-quantity-down");

    if (this.quantityInput && this.quantityUp && this.quantityDown) {
      this.updateQuantityDown = this.updateQuantityDown.bind(this);
      this.updateQuantityUp = this.updateQuantityUp.bind(this);

      this.quantityDown.addEventListener("click", this.updateQuantityDown);
      this.quantityUp.addEventListener("click", this.updateQuantityUp);
    }

    this.productForm();
    this.klaviyoNotifyMe();

    if (this.tagName == "PRODUCT-SIZE-GUIDE") {
      this.sizeGuideContainer = document.querySelector(".js-size-guide");
      this.sizeGuideCloseButtons = document.querySelectorAll(
        ".js-close-size-guide"
      );
      this.sizeGuideOpenButton = document.querySelector(".js-open-size-guide");

      this.initSizeGuide();
    }

    if (this.tagName == "PRODUCT-BOTTOM-BAR") {
      this.initializeBottomBar();
    }

    if (
      this.tagName != "PRODUCT-SIZE-GUIDE" &&
      this.tagName != "PRODUCT-BOTTOM-BAR"
    ) {
      this.initializeProductImagesZoom();
      this.initializeMobileCarousel();
      if (document.querySelector(".js-key-ingredients-top-carousel")) {
        this.initializeIngredientsCarousel();
      }
      if (document.querySelector(".js-related-products")) {
        this.initializeRelatedProducts();
      }
      if (document.querySelector(".js-product-tab")) {
        this.initializeProductTabs();
      }
      if (document.querySelector(".js-product-tab-video")) {
        this.initializeProductTabsVideos();
      }
    }
  }

  productForm() {
    const variants = (productId) => {
      const data = JSON.parse(
        document.getElementById(`ProductJson${productId}`).innerHTML
      );

      const selectCallback = (variant) => {
        const that = this.querySelector(
          `.js-product[data-product-id='${productId}']`
        );
        let soldOut = true;

        if (variant) {
          that.querySelectorAll(".js-product-size").forEach((sizeElement) => {
            let soldOut = true;
            const value = sizeElement.getAttribute("data-value");
            const option = sizeElement.getAttribute("data-option");

            const selectedOptions = {};
            that
              .querySelectorAll(
                `.js-product[data-product-id='${productId}'] .selector-wrapper select`
              )
              .forEach((select) => {
                const optionName = select.getAttribute("data-option");
                if (optionName != option) {
                  selectedOptions[optionName] = select.value;
                }
              });

            document
              .querySelectorAll(
                `.js-product[data-product-id='${productId}'] select[name='id'] option`
              )
              .forEach((option) => {
                const option1 = option.getAttribute("data-option-1");
                const option2 = option.getAttribute("data-option-2");
                const option3 = option.getAttribute("data-option-3");

                const matchesSelectedOptions =
                  (!selectedOptions["option1"] ||
                    option1 === selectedOptions["option1"]) &&
                  (!selectedOptions["option2"] ||
                    option2 === selectedOptions["option2"]) &&
                  (!selectedOptions["option3"] ||
                    option3 === selectedOptions["option3"]);

                if (
                  matchesSelectedOptions &&
                  (option1 === value || option2 === value || option3 === value)
                ) {
                  if (!option.hasAttribute("disabled")) {
                    soldOut = false;
                  }
                }
              });

            if (soldOut) {
              sizeElement.classList.add("out-of-stock");
            } else {
              sizeElement.classList.remove("out-of-stock");
            }
          });

          const priceOldElement = that.querySelector(".js-price-old");
          const priceNewElement = that.querySelector(".js-price-new");
          const priceDefaultElement = that.querySelector(".js-price-default");

          if (variant.compare_at_price > variant.price) {
            if (priceOldElement) {
              priceOldElement.classList.remove("d-none");
              priceOldElement.innerHTML = Shopify.formatMoney(
                variant.compare_at_price
              );
            }
            if (priceNewElement) {
              priceNewElement.classList.remove("d-none");
              priceNewElement.innerHTML = Shopify.formatMoney(variant.price);
            }
            if (priceDefaultElement) {
              priceDefaultElement.classList.add("d-none");
            }
          } else {
            if (priceOldElement) priceOldElement.classList.add("d-none");
            if (priceNewElement) priceNewElement.classList.add("d-none");
            if (priceDefaultElement) {
              priceDefaultElement.classList.remove("d-none");
              priceDefaultElement.innerHTML = Shopify.formatMoney(
                variant.price
              );
            }
          }

          if (variant.featured_media) {
            that
              .querySelector(".js-add-to-cart")
              .setAttribute(
                "data-featured-image",
                variant.featured_media.preview_image.src
              );
          }
        }

        const productForm = that.querySelector(".js-product-form");
        const productJoinWaitList = that.querySelector(
          ".js-product-out-of-stock"
        );

        if (variant.available) {
          productForm.classList.remove("d-none");
          productJoinWaitList.classList.add("d-none");
        } else {
          productForm.classList.add("d-none");
          productJoinWaitList.classList.remove("d-none");
        }

        const selectedOption = this.querySelector(
          ".js-current-variant option:checked"
        );
        const lastFewRemaining = this.querySelector(".js-last-few-remaining");

        if (selectedOption && lastFewRemaining) {
          const quantity = parseInt(
            selectedOption.getAttribute("data-quantity")
          );

          if (quantity < 5 && quantity > 0) {
            lastFewRemaining.classList.remove("d-none");
          } else {
            lastFewRemaining.classList.add("d-none");
          }
        } else if (lastFewRemaining) {
          lastFewRemaining.classList.add("d-none");
        }

        if (selectedOption) {
          var addToCartBtn = this.querySelector(".js-add-to-cart");
          var preOrderText = addToCartBtn.getAttribute("data-preorder-text");
          var originalText = addToCartBtn.getAttribute("data-original-text");
          var preOrderInfo = this.querySelector(".js-product-pre-order-text");

          var continueSelling =
            selectedOption.getAttribute(
              "data-continue-selling-when-out-of-stock"
            ) === "true";
          var quantity = parseInt(
            selectedOption.getAttribute("data-quantity"),
            10
          );

          var span = addToCartBtn.querySelector("span");

          if (span) {
            if (continueSelling && quantity < 1) {
              span.textContent = preOrderText;

              if (lastFewRemaining) {
                lastFewRemaining.classList.add("d-none");
              }

              productForm.classList.remove("d-none");
              productForm.classList.add("with-preorder");
              productJoinWaitList.classList.add("d-none");

              if (preOrderInfo) {
                preOrderInfo.classList.remove("d-none");
              }
            } else {
              span.textContent = originalText;
              if (preOrderInfo) {
                preOrderInfo.classList.add("d-none");
              }
              productForm.classList.remove("with-preorder");
            }
          }
        }
      };

      if (document.getElementById(`product-select-${productId}`)) {
        new Shopify.OptionSelectors(`product-select-${productId}`, {
          product: data,
          onVariantSelected: selectCallback,
          enableHistoryState: true,
        });
      }
    };

    this.querySelectorAll(".js-product:not(.active)").forEach((element) => {
      const productId = element.getAttribute("data-product-id");
      const json = document.getElementById(`ProductJson${productId}`);

      if (json) {
        variants(productId);

        element.querySelectorAll(".js-product-size").forEach((sizeElement) => {
          sizeElement.addEventListener("click", function (event) {
            event.preventDefault();

            const value = this.getAttribute("data-value");
            const option = this.closest("ul").getAttribute("data-option");

            const productVariants = document.querySelector(
              `.js-product[data-product-id='${productId}'] select[data-option='${option}']`
            );
            if (productVariants) {
              productVariants.value = value;
              productVariants.dispatchEvent(new Event("change"));

              const optionValues = document.querySelectorAll(
                `.js-product[data-product-id='${productId}'] .js-product-size[data-option="${option}"]`
              );
              if (optionValues.length) {
                optionValues.forEach((optionValue) => {
                  optionValue.classList.remove("active");
                });

                this.classList.add("active");
              }
            }
          });
        });

        element
          .querySelectorAll(".js-mobile-product-option")
          .forEach((mobileSelect) => {
            mobileSelect.addEventListener("change", function () {
              const wrapper = this.closest(".js-mobile-product-bar-option");
              const value = this.value;
              const option = wrapper.getAttribute("data-option");
              const productId = wrapper.getAttribute("data-product-id");

              const productVariants = document.querySelector(
                `.js-product[data-product-id='${productId}'] select[data-option='${option}']`
              );
              if (productVariants) {
                productVariants.value = value;
                productVariants.dispatchEvent(new Event("change"));

                const optionValues = document.querySelectorAll(
                  `.js-product[data-product-id='${productId}'] .js-product-size[data-option="${option}"]`
                );
                if (optionValues.length) {
                  optionValues.forEach((optionValue) => {
                    optionValue.classList.remove("active");
                    if (optionValue.getAttribute("data-value") === value) {
                      optionValue.classList.add("active");
                    }
                  });
                }
              }
            });
          });
      }

      element.classList.add("active");
    });
  }

  klaviyoNotifyMe() {
    document.body.addEventListener("click", function (e) {
      const target = e.target.closest(".js-product-out-of-stock a");
      if (target) {
        const bisTrigger = document.querySelector(".klaviyo-bis-trigger");
        if (bisTrigger) bisTrigger.click();
        e.preventDefault();
      }
    });
  }

  initSizeGuide() {
    if (!this.sizeGuideContainer || !this.sizeGuideOpenButton) return;

    this.sizeGuideOpenButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.toggleSizeGuide();
    });

    this.sizeGuideCloseButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        this.closeSizeGuide();
      });
    });
  }

  toggleSizeGuide() {
    const isActive = this.sizeGuideContainer.classList.contains("active");
    if (!isActive) {
      this.openSizeGuide();
    } else {
      this.closeSizeGuide();
    }
  }

  openSizeGuide() {
    this.sizeGuideContainer.classList.add("display");

    this.sizeGuideCloseButtons.forEach((btn) => btn.classList.add("display"));

    setTimeout(() => {
      this.sizeGuideContainer.classList.add("active");
      this.sizeGuideCloseButtons.forEach((btn) => btn.classList.add("active"));
    }, 50);
  }

  closeSizeGuide() {
    this.sizeGuideContainer.classList.add("closing");

    this.sizeGuideCloseButtons.forEach((btn) => btn.classList.add("closing"));

    setTimeout(() => {
      this.sizeGuideContainer.classList.remove("active", "closing", "display");
      this.sizeGuideCloseButtons.forEach((btn) =>
        btn.classList.remove("active", "closing", "display")
      );
    }, 300);
  }

  updateQuantityDown(event) {
    event.preventDefault();
    if (!this.quantityInput) return;

    let currentValue = parseInt(this.quantityInput.value, 10) || 1;
    if (currentValue > 1) {
      this.quantityInput.value = currentValue - 1;
    }
  }

  updateQuantityUp(event) {
    event.preventDefault();
    if (!this.quantityInput) return;

    let currentValue = parseInt(this.quantityInput.value, 10) || 1;
    this.quantityInput.value = currentValue + 1;
  }

  initializeBottomBar() {
    const bottomBar = document.querySelector(".js-product-bottom-bar");
    if (!bottomBar) return;

    const productForm = document.querySelector("product-page .js-product");
    if (!productForm) return;

    function checkScrollPosition() {
      const formRect = productForm.getBoundingClientRect();

      const isOutOfView =
        formRect.bottom < 0 || formRect.top > window.innerHeight;

      if (isOutOfView) {
        bottomBar.classList.add("active");
      } else {
        bottomBar.classList.remove("active");
      }
    }

    checkScrollPosition();
    window.addEventListener("scroll", checkScrollPosition);
    window.addEventListener("resize", checkScrollPosition);
  }

  initializeProductImagesZoom() {
    const openButtons = document.querySelectorAll(
      ".js-open-product-zoom-images"
    );
    const zoomContainer = document.querySelector(".js-product-zoom-images");
    const closeButton = document.querySelector(".js-close-product-zoom-images");
    const goToImageButtons = document.querySelectorAll(
      ".js-go-to-product-image"
    );

    openButtons.forEach((button) => {
      button.addEventListener("click", function () {
        if (window.innerWidth > 991 && zoomContainer) {
          const index = this.getAttribute("data-index");
          zoomContainer.classList.add("display");
          document.body.style.overflow = "hidden";

          setTimeout(() => {
            zoomContainer.classList.add("active");

            if (index && zoomContainer) {
              const targetImage = zoomContainer.querySelector(
                `.js-product-image[data-index="${index}"]`
              );
              if (targetImage) {
                targetImage.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                  inline: "center",
                });
              }
            }
          }, 50);
        }
      });
    });

    if (closeButton && zoomContainer) {
      closeButton.addEventListener("click", function () {
        zoomContainer.classList.add("closing");
        setTimeout(() => {
          zoomContainer.classList.remove("active", "closing", "display");
          document.body.style.overflow = "";
        }, 300);
      });
    }

    goToImageButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const index = this.getAttribute("data-index");
        const targetImage = document.querySelector(
          `.js-product-image[data-index="${index}"]`
        );

        if (targetImage && zoomContainer) {
          targetImage.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
        }
      });
    });
  }

  initializeMobileCarousel() {
    const containers = document.querySelectorAll(
      ".js-mobile-carousel:not([data-initialized])"
    );
    const progressBars = document.querySelectorAll(
      ".js-scroll-bar:not([data-initialized])"
    );

    containers.forEach((container, index) => {
      container.setAttribute("data-initialized", "true");
      const progressBar = progressBars[index];
      progressBar.setAttribute("data-initialized", "true");

      container.addEventListener("scroll", () => {
        const scrollLeft = container.scrollLeft;
        const scrollWidth = container.scrollWidth - container.clientWidth;
        const scrollPercentage = (scrollLeft / scrollWidth) * 100;

        if (progressBar) {
          progressBar.style.width = `${scrollPercentage}%`;
        }
      });
    });
  }

  initializeIngredientsCarousel() {
    const carousel = document.querySelector(".js-key-ingredients-top-carousel");
    const ingredients = carousel.querySelectorAll(
      ".js-key-ingredients-top-item"
    );

    let lastIndex = 0;

    if (!carousel || ingredients.length < 5) {
      carousel.classList.add("inactive");
      document.querySelectorAll(".js-change-key-ingredient").forEach((btn) => {
        btn.addEventListener("click", (event) => {
          event.preventDefault();
          const index = parseInt(btn.dataset.index, 10) - 1;
          const distance = Math.abs(index - lastIndex);
          lastIndex = index;

          const duration = 0.3 + distance * 0.2;

          const keyIngredients =
            document.querySelectorAll(".js-key-ingredient");

          keyIngredients.forEach((item) => {
            item.style.transition = `transform ${duration}s ease`;
            item.style.transform = `translateX(-${index * 100}%)`;
          });
        });
      });
      return;
    }

    if (window.innerWidth > 991) {
      document
        .querySelectorAll(".js-key-ingredients-top-carousel")
        .forEach((element, index) => {
          const uniqueClass = `js-key-ingredients-top-carousel-${String(
            index + 1
          ).padStart(2, "0")}`;
          element.classList.add(uniqueClass);

          const splide = new Splide(element, {
            type: "slide",
            focus: "center",
            autoWidth: true,
          });

          splide.mount();
          element.splideInstance = splide;
        });
    }

    document.querySelectorAll(".js-change-key-ingredient").forEach((btn) => {
      btn.addEventListener("click", (event) => {
        event.preventDefault();
        const index = parseInt(btn.dataset.index, 10) - 1;
        const distance = Math.abs(index - lastIndex);
        lastIndex = index;

        const duration = 0.3 + distance * 0.2;

        const keyIngredients = document.querySelectorAll(".js-key-ingredient");

        keyIngredients.forEach((item) => {
          item.style.transition = `transform ${duration}s ease`;
          item.style.transform = `translateX(-${index * 100}%)`;
        });
      });
    });
  }

  initializeRelatedProducts() {
    const carousels = document.querySelectorAll(
      ".js-related-products:not([data-initialized])"
    );
    const progressBars = document.querySelectorAll(
      ".js-related-products-pagination-progress:not([data-initialized])"
    );

    carousels.forEach((carousel, index) => {
      const progressBar = progressBars[index];
      if (!progressBar) return;

      carousel.setAttribute("data-initialized", "true");
      progressBar.setAttribute("data-initialized", "true");

      const products = carousel.querySelectorAll(".js-related-product");
      if (!products.length) return;

      if (window.innerWidth > 991) {
        const uniqueClass = `js-related-products-${index}`;
        carousel.classList.add(uniqueClass);

        const splide = new Splide(carousel, {
          type: "slide",
          gap: "20px",
          perPage: 3,
          rewind: false,
          arrows: false,
          pagination: false,
          breakpoints: {
            767: { perPage: 2, gap: "20px" },
            991: { perPage: 3, gap: "20px" },
            1298: { perPage: 3, gap: "20px" },
            1440: { perPage: 3, gap: "20px" },
          },
        });

        const updateProgressBar = () => {
          const totalSlides = splide.Components.Controller.getEnd() + 1;
          const currentSlide = splide.index + 1;

          const scrollPercentage = (currentSlide / totalSlides) * 100;
          const clampedPercentage = Math.min(
            100,
            Math.max(0, scrollPercentage)
          );

          progressBar.style.width = `${clampedPercentage}%`;
        };

        splide.mount();
        updateProgressBar();
        splide.on("move", updateProgressBar);
        splide.on("mounted", updateProgressBar);

        carousel.__splideInstance = splide;
      } else {
        carousel.addEventListener("scroll", () => {
          const scrollLeft = carousel.scrollLeft;
          const scrollWidth = carousel.scrollWidth - carousel.clientWidth;
          const scrollPercentage =
            scrollWidth > 0 ? (scrollLeft / scrollWidth) * 100 : 0;
          const clampedPercentage = Math.min(
            100,
            Math.max(0, scrollPercentage)
          );
          progressBar.style.width = `${clampedPercentage}%`;
        });
      }
    });
  }

  initializeProductTabs() {
    const toggles = document.querySelectorAll(".js-toggle-product-tab");

    toggles.forEach(function (toggle) {
      toggle.addEventListener("click", function () {
        const parentTab = toggle.closest(".js-product-tab");
        const content = parentTab.querySelector(".js-product-tab-content");
        const allTabs = document.querySelectorAll(".js-product-tab");

        allTabs.forEach(function (tab) {
          if (tab !== parentTab) {
            tab.classList.remove("active");
            const tabContent = tab.querySelector(".js-product-tab-content");
            if (tabContent) {
              tabContent.style.maxHeight = "0px";
            }
          }
        });

        parentTab.classList.toggle("active");

        if (parentTab.classList.contains("active")) {
          content.style.maxHeight = content.scrollHeight + "px";
        } else {
          content.style.maxHeight = "0px";
        }
      });
    });
  }

  initializeProductTabsVideos() {
    document.querySelectorAll(".js-product-tab-video").forEach((video) => {
      video.removeAttribute("controls");
    });

    document.querySelectorAll(".js-play-video").forEach((button) => {
      button.addEventListener("click", function () {
        const video = this.closest(".js-product-tab")?.querySelector(
          ".js-product-tab-video"
        );
        if (!video) return;

        if (this.classList.contains("active")) {
          video.pause();
          video.currentTime = 0;
          this.classList.remove("active");
        } else {
          video.play();
          this.classList.add("active");
        }
      });
    });
  }
}

if (document.querySelector("product-page")) {
  customElements.define("product-page", Product);
}

class ProductSizeGuide extends Product {}

if (document.querySelector("product-size-guide")) {
  customElements.define("product-size-guide", ProductSizeGuide);
}

class ProductBottomBar extends Product {}

if (document.querySelector("product-bottom-bar")) {
  customElements.define("product-bottom-bar", ProductBottomBar);
}
